import { useConfig } from '@/composables';
import { FeatureFlagKey } from '@/features';
import { defineStore } from 'pinia';
import { ref } from 'vue';

const config = useConfig();

export const useFeatureFlagsStore = defineStore('featureFlagsStore', () => {
  const featureFlags = ref(config.value.featureFlags ?? {});

  const isEnabled = (flagKey: FeatureFlagKey): boolean => {
    return featureFlags.value[flagKey] ?? false;
  };

  return {
    featureFlags,
    isEnabled,
  };
});
